<template>
        <div class="move_map">
          <baidu-map
            :center="center"
            :zoom="zoom"
            @ready="handler"
            class="bm-view"
            :scroll-wheel-zoom="true"
          >
            <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
            <bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :showAddressBar="true" :autoLocation="true"></bm-geolocation>
            <bm-city-list anchor="BMAP_ANCHOR_TOP_LEFT"></bm-city-list>
            <bm-marker
              :position="{lng: 114.47033, lat: 38.030704}"
              :dragging="true"
              animation="BMAP_ANIMATION_BOUNCE"
            >
              <bm-label
                content="飞天科技"
                :labelStyle="{color: '#e50012', fontSize : '24px'}"
                :offset="{width: -35, height: 30}"
                @click="infoWindowOpen"
              />
              <bm-info-window
                :show="infoWindow.show"
                @close="infoWindowClose"
                @open="infoWindowOpen"
                style="font-size: 14px"
              >
                <h4>石家庄飞天科技技术有限公司</h4>
                <p>电话：0311-85048504</p>
                <p>公司地址：石家庄市槐安西路88号卓达中苑商务大厦B座305</p>
              </bm-info-window>
            </bm-marker>
          </baidu-map>
        </div>
      </template>

      <script>
      export default {
        data() {
          return {
            center: { lng: 0, lat: 0 },
            zoom: 3,
            infoWindow: {
              show: false,
              contents:
                "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
            }
          };
        },
        methods: {
          handler({ BMap, map }) {
            this.center.lng = 114.47033;
            this.center.lat = 38.030704;
            this.zoom = 14;
          },
          infoWindowClose(e) {
            this.infoWindow.show = false;
          },
          infoWindowOpen(e) {
            this.infoWindow.show = true;
          },
          clear() {
            this.infoWindow.contents = "";
          }
        }
      };
      </script>

      <style lang="less">

       .move_map{

            .bm-view {
            width: 100%;
            height: 160px;
            margin: 30px 0;
          }
          .BMapLabel {
            background-color: rgba(0, 0, 0, 0.5) !important;
            border: 0px !important;
            color: white !important;
            padding: 5px !important;
            left: -20px !important;
            font-size: 12px !important;
          }
          .BMap_bubble_content div h4{
            font-size: 14px;
            font-weight: bold;
            line-height: 28px;
          }
          .BMap_bubble_content div p{
            font-size: 14px;
            white-space:nowrap;
          }
       }

      </style>



// WEBPACK FOOTER //
// src/components/move/map.vue